import React, { Component, useReducer } from 'react';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import Loading from '../images/loading.png'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

  class Client extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
          client: {},
          loading: true,
          measurements: []
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.HistoricalMeasurements = () => {
        var measurements = this.state.measurements

        if(measurements.length == 0){
          return<div>
            No measurements recorded
          </div>
        }else{
          measurements.sort((b, a) => a.date.localeCompare(b.date));
          var measurements_map = measurements.map((item, index) => {
            return<div style={{margin: '10px', textAlign: 'left', border: '1px solid silver', borderRadius: '20px'}}>
              <Container>
                Date Recorded: {item.date.slice(0,-10)}
                <br/><br/>
                <Row>
                  <Col sm='3'>
                    Weight (kgs):
                    <br/>
                    {item.weight}
                  </Col>
                  <Col>
                    Height (cms):
                    <br/>
                    {item.height}
                  </Col>
                  <Col>
                    Left bicep (cms):
                    <br/>
                    {item.left_bicep}
                  </Col>
                  <Col>
                    Right bicep (cms):
                    <br/>
                    {item.right_bicep}
                  </Col>
                </Row>
                <br/>
                <Row>
                  <Col sm='3'>
                    Chest (cms):
                    <br/>
                    {item.chest}
                  </Col>
                  <Col>
                    Waist (cms):
                    <br/>
                    {item.waist}
                  </Col>
                  <Col>
                    Hips (cms):
                    <br/>
                    {item.hips}
                  </Col>
                  <Col>
                    Calf (cms):
                    <br/>
                    {item.calf}
                  </Col>
                </Row>
                <br/>
                <Row>
                  <Col sm='3'>
                    Left leg (cms):
                    <br/>
                    {item.left_leg}
                  </Col>
                  <Col>
                    Right leg (cms):
                    <br/>
                    {item.right_leg}
                    <br/><br/>
                  </Col>
                  <Col>
                    <br/><br/>
                  </Col>
                  <Col>
                    <br/><br/>
                  </Col>
                </Row>
              </Container>
            </div>
          })
          return<div style={{maxHeight: '600px', overflowY: 'scroll'}}>
            {measurements_map}
          </div>
        }
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)
      
      const { cookies } = this.props;
      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))
      data.append('user_id', this.props.user_id)

      axios.post(Backend_Url + 'user', data)
      .then((res) => {
          let result = res.data
            this.setState({client: result})
      }).catch((error) => {
          console.log(error)
      })

      axios.post(Backend_Url + 'userMeasurements', data)
      .then((res) => {
          let result = res.data
          this.setState({
            measurements: result, 
            loading: false
          })
      }).catch((error) => {
          console.log(error)
      })
    }




    render() {
      if(this.state.loading){
        return (
          <Row>
              <Helmet>
                <title>CLIENT- ONFIT</title>
                {/* <meta name="description" content="" /> */}
              </Helmet>
              <div style={{minHeight: '900px', backgroundColor: '#ffffff', opacity: 0.9}}>
                <br/><br/>
                <img src={Loading} style={{width: '30%'}}/>
                <br/><br/><br/>
              </div>
          </Row>
        );
      }
      var client = this.state.client
      var measurements = this.state.measurements
      var recent_measurements = {}
      if(measurements.length != 0){
        measurements.sort((b, a) => a.date.localeCompare(b.date));
        recent_measurements = measurements[0]
      }
      var respiration_rate = []
      return (
        <Row>
            <Helmet>
              <title>CLIENT - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Client
              </h4>
              <br/>
              <Container>
                <Row style={{textAlign: 'left'}}>
                    <Col sm='3'>
                        <h6 style={{fontWeight: 'bold'}}>{client.firstname} {client.lastname}</h6>
                        <br/>
                        <img src={Backend_Url + 'media/' + client.image} style={{width: '100%'}}/>
                    </Col>
                    <Col>
                        <Row>
                            <Col sm='6'>
                                <h6 style={{fontWeight: 'bold'}}>Email:</h6>
                                <br/>
                            </Col>
                            <Col>
                                {client.email}
                                <br/>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col sm='6'>
                                <h6 style={{fontWeight: 'bold'}}>Phonenumber:</h6>
                                <br/>
                            </Col>
                            <Col>
                                {client.phonenumber}
                                <br/>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col sm='6'>
                                <h6 style={{fontWeight: 'bold'}}>Bio:</h6>
                                <br/>
                            </Col>
                            <Col>
                                {client.bio}
                                <br/>
                            </Col>
                        </Row>
                        <br/><br/>
                        <Row>
                          <Col sm='4' style={{textAlign: 'left'}}>
                            <h6 style={{fontWeight: 'bold'}}>Weekly Schedule</h6>
                            <br/>
                            {client.schedule}
                          </Col>
                          <Col sm='4' style={{textAlign: 'left'}}>
                            <h6 style={{fontWeight: 'bold'}}>Fitness Goals</h6>
                            <br/>
                            {client.goals}
                          </Col>
                          <Col sm='4' style={{textAlign: 'left'}}>
                            <h6 style={{fontWeight: 'bold'}}>Training Methods</h6>
                            <br/>
                            {client.methods}
                          </Col>
                        </Row>
                        <br/><br/>
                        <h5 style={{fontWeight: 'bold', color: '#1faced'}}>
                          Measurements <span style={{fontSize: '13px'}}>(Last updated: {recent_measurements.date})</span>
                        </h5>
                        <br/>
                        <Row>
                          <Col sm='6'>
                            <Row>
                              <Col xs='6'>
                                <h6 style={{fontWeight: 'bold'}}>Weight:</h6>
                                <br/>
                              </Col>
                              <Col>
                                {recent_measurements.weight}
                                <br/>
                              </Col>
                            </Row>
                            <br/>
                            <Row>
                              <Col xs='6'>
                                <h6 style={{fontWeight: 'bold'}}>Height:</h6>
                                <br/>
                              </Col>
                              <Col>
                                {recent_measurements.height}
                                <br/>
                              </Col>
                            </Row>
                            <br/>
                            <Row>
                              <Col xs='6'>
                                <h6 style={{fontWeight: 'bold'}}>Left Bicep:</h6>
                                <br/>
                              </Col>
                              <Col>
                                {recent_measurements.left_bicep}
                                <br/>
                              </Col>
                            </Row>
                            <br/>
                            <Row>
                              <Col xs='6'>
                                <h6 style={{fontWeight: 'bold'}}>Right Bicep:</h6>
                                <br/>
                              </Col>
                              <Col>
                                {recent_measurements.right_bicep}
                                <br/>
                              </Col>
                            </Row>
                            <br/>
                            <Row>
                              <Col xs='6'>
                                <h6 style={{fontWeight: 'bold'}}>Chest:</h6>
                                <br/>
                              </Col>
                              <Col>
                                {recent_measurements.chest}
                                <br/>
                              </Col>
                            </Row>
                            <br/>
                          </Col>
                          <Col>
                            <Row>
                              <Col xs='6'>
                                <h6 style={{fontWeight: 'bold'}}>Waist:</h6>
                                <br/>
                              </Col>
                              <Col>
                                {recent_measurements.waist}
                                <br/>
                              </Col>
                            </Row>
                            <br/>
                            <Row>
                              <Col xs='6'>
                                <h6 style={{fontWeight: 'bold'}}>Hips:</h6>
                                <br/>
                              </Col>
                              <Col>
                                {recent_measurements.hips}
                                <br/>
                              </Col>
                            </Row>
                            <br/>
                            <Row>
                              <Col xs='6'>
                                <h6 style={{fontWeight: 'bold'}}>Calf:</h6>
                                <br/>
                              </Col>
                              <Col>
                                {recent_measurements.calf}
                                <br/>
                              </Col>
                            </Row>
                            <br/>
                            <Row>
                              <Col xs='6'>
                                <h6 style={{fontWeight: 'bold'}}>Left Leg:</h6>
                                <br/>
                              </Col>
                              <Col>
                                {recent_measurements.left_leg}
                                <br/>
                              </Col>
                            </Row>
                            <br/>
                            <Row>
                              <Col xs='6'>
                                <h6 style={{fontWeight: 'bold'}}>Right Leg:</h6>
                                <br/>
                              </Col>
                              <Col>
                                {recent_measurements.right_leg}
                                <br/>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                    </Col>
                </Row>
                <br/><br/>
                <h6 style={{fontWeight: 'bold', color: '#1faced'}}>Metrics</h6>
                <br/><br/>
                <Container>
                    <Row>
                      <Col>
                        Start Date:
                        <br/>
                        <Input name='start_date' value={this.state.start_date} type='date'
                          style={{}} />
                      </Col>
                      <Col>
                        End Date:
                        <br/>
                        <Input name='end_date' value={this.state.end_date} type='date'
                          style={{}} />
                      </Col>
                    </Row>
                    <br/><br/>
                    <Row>
                      <Col sm='4' style={{height: '350px'}}>
                        <h6 style={{fontWeight: 'bold'}}>Respiration Rate</h6>
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart
                            width={500}
                            height={300}
                            data={respiration_rate}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="time" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="rate" stroke="#1faced" activeDot={{ r: 8 }} />
                          </LineChart>
                        </ResponsiveContainer>
                      </Col>
                      <Col sm='4' style={{height: '350px'}}>
                        <h6 style={{fontWeight: 'bold'}}>Oxygen Saturation</h6>
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart
                            width={500}
                            height={300}
                            data={respiration_rate}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="time" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="saturation" stroke="#1faced" activeDot={{ r: 8 }} />
                          </LineChart>
                        </ResponsiveContainer>
                      </Col>
                      <Col sm='4' style={{height: '350px'}}>
                        <h6 style={{fontWeight: 'bold'}}>Systolic Blood Pressure</h6>
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart
                            width={500}
                            height={300}
                            data={respiration_rate}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="time" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="rate" stroke="#1faced" activeDot={{ r: 8 }} />
                          </LineChart>
                        </ResponsiveContainer>
                      </Col>
                    </Row>
                    <br/><br/><br/>
                    <Row>
                      <Col sm='4' style={{height: '350px'}}>
                        <h6 style={{fontWeight: 'bold'}}>Pulse Rate</h6>
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart
                            width={500}
                            height={300}
                            data={respiration_rate}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="time" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="rate" stroke="#1faced" activeDot={{ r: 8 }} />
                          </LineChart>
                        </ResponsiveContainer>
                      </Col>
                      <Col sm='4' style={{height: '350px'}}>
                        <h6 style={{fontWeight: 'bold'}}>Temperature</h6>
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart
                            width={500}
                            height={300}
                            data={respiration_rate}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="time" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="degrees" stroke="#1faced" activeDot={{ r: 8 }} />
                          </LineChart>
                        </ResponsiveContainer>
                      </Col>
                      <Col sm='4' style={{height: '350px'}}>
                        <h6 style={{fontWeight: 'bold'}}>Steps</h6>
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart
                            width={500}
                            height={300}
                            data={respiration_rate}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="time" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="steps" stroke="#1faced" activeDot={{ r: 8 }} />
                          </LineChart>
                        </ResponsiveContainer>
                      </Col>
                    </Row>
                    <br/><br/><br/>
                    <Row>
                      <Col sm='4' style={{height: '350px'}}>
                        <h6 style={{fontWeight: 'bold'}}>Sleep</h6>
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart
                            width={500}
                            height={300}
                            data={respiration_rate}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="time" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="hours" stroke="#1faced" activeDot={{ r: 8 }} />
                          </LineChart>
                        </ResponsiveContainer>
                      </Col>
                      <Col sm='4' style={{height: '350px'}}>
                        <h6 style={{fontWeight: 'bold'}}>Weight</h6>
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart
                            width={500}
                            height={300}
                            data={respiration_rate}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="time" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="kgs" stroke="#1faced" activeDot={{ r: 8 }} />
                          </LineChart>
                        </ResponsiveContainer>
                      </Col>
                      <Col sm='4' style={{height: '350px'}}>
                        <h6 style={{fontWeight: 'bold'}}>Blood Sugar</h6>
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart
                            width={500}
                            height={300}
                            data={respiration_rate}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="time" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="milligrams" stroke="#1faced" activeDot={{ r: 8 }} />
                          </LineChart>
                        </ResponsiveContainer>
                      </Col>
                    </Row>
                </Container>
                <br/><br/>
                <h6 style={{fontWeight: 'bold', color: '#1faced'}}>Historical Measurements</h6>
                <br/><br/>
                <this.HistoricalMeasurements/>
                <br/><br/><br/><br/>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(Client);